<template>
    <v-app>
        <v-layout row wrap v-scroll="scrollAction">
            <v-flex ref="monitors" id="monitors" xs12>
                <v-card flat class="pa-2">
                    <v-layout align-center row fill-height>
                        <v-flex md8 xs6 pa-3>
                            <span class="subheading font-weight-bold pa-2">Choose Monitor to compare each other</span><br>
                            <span class="body-2 px-2" v-show="selectedMonitors.length < 1"><v-icon small color="negative">fas fa-exclamation-triangle</v-icon>  You haven't chosen any monitor to compare yet.</span>
                            <span class="body-2 px-2" v-show="selectedMonitors.length !== 0">You have chosen {{selectedMonitors.length}} monitor.</span>
                        </v-flex>
                        <v-flex text-xs-right xs6 md4>
                            <v-btn
                                color="bindezcolor"
                                dark
                                depressed
                                @click="compareMonitorDialog = true"
                                :loading="!allMonitorFetchReady"
                            >
                                <span class="text-capitalize">Choose Monitor</span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>

            <v-dialog
                v-model="compareMonitorDialog"
                persistent
                max-width="900"
            >
                <v-card flat>
                    <v-layout row wrap pa-3>
                        <v-flex xs5>
                            <v-text-field
                                    @click:clear="searchMonitorValue = undefined"
                                    background-color="#f4f4f4"
                                    class="search-box--height"
                                    clearable
                                    flat
                                    height="41"
                                    hide-details
                                    label="Search Monitor"
                                    solo
                                    v-model="searchMonitorValue"
                            >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs2>
                            <v-btn
                                    class="mt-0"
                                    color="bindezcolor"
                                    dark
                                    depressed
                                    small
                            >
                                <span class="text-capitalize subheading font-weight-regular">Search</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs5 text-xs-center>
                            <v-radio-group v-model="monitorFilter" row hide-details class="mt-1">
                                <v-radio :ripple="false" class="custom-checkbox-size custom-position" color="bindezcolor" :label="`All(${allAvailableMonitors.length})`" value="all"></v-radio>
                                <v-radio :ripple="false" class="custom-checkbox-size custom-position" color="bindezcolor" :label="`Select(${monitorsToCompare.length})`" value="select"></v-radio>
                                <v-radio :ripple="false" class="custom-checkbox-size custom-position" color="bindezcolor" :label="`Unselect(${unSelectMonitor.length})`" value="unselect"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex xs12>
                            <div class="font-weight-bold caption py-2" v-show="selectedCompareMonitors.length === 5">
                                <v-icon small color="negative">fas fa-exclamation-triangle</v-icon> You can only compare up to 6 monitors
                            </div>
                        </v-flex>
                        <v-flex xs12>
                            <v-data-table
                                    :custom-filter="customMonitorFilter"
                                    :headers="headers"
                                    :items="allAvailableMonitors"
                                    :key="selectedMonitors.length"
                                    :loading="!allMonitorFetchReady"
                                    :pagination.sync="pagination"
                                    :search="searchMonitorValue"
                                    class="text-capitalize elevation-1"
                                    hide-actions
                                    item-key="monitor_uuid"
                                    select-all
                                    v-model="selectedCompareMonitors"
                            >
                                <v-progress-linear color="bindezcolor" indeterminate
                                                   slot="progress"></v-progress-linear>
                                <template
                                        slot="headers"
                                        slot-scope="props"
                                >
                                    <tr>
                                        <th></th>
                                        <th :key="header.text"
                                            class="text-xs-left font-weight-regular subheading"
                                            v-for="header in props.headers">
                                            {{ header.text}}
                                        </th>
                                    </tr>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <tr style="cursor:pointer;">
                                        <td>
                                            <v-checkbox
                                                    :disabled="disabledMonitors(props.item)"
                                                    :value="props.item.monitor_uuid === monitor_uuid"
                                                    class="custom-checkbox-size"
                                                    color="bindezcolor"
                                                    hide-details
                                                    v-model="props.selected"
                                            />
                                        </td>
                                        <td class="text-xs-left body-2 table-text--color">
                                            <div :class="{'text-truncate' : $vuetify.breakpoint.lgAndDown}"
                                                 class="zawgyi"
                                                 style="max-width: 200px;"
                                            >
                                                {{ props.item.name | unescapeString | textTruncate }}
                                            </div>
                                        </td>
                                        <td class="text-xs-left body-2 table-text--color">
                                            <div :class="{'text-truncate' : $vuetify.breakpoint.lgAndDown}"
                                                 class="zawgyi"
                                                 style="max-width: 200px;"
                                            >
                                                <span style="font-size:0.65rem; display: inline-block; color:var(--bindez-green-color); width: auto; height: auto; padding: 2px;">{{ props.item.type === 'keyword' ? 'BUZZ' : 'PAGE'}}</span>
                                            </div>
                                        </td>
                                        <td class="text-xs-left body-2 table-text--color">
                                            <div
                                                    class="zawgyi text-truncate"
                                                    style="max-width: 200px;"
                                            >
                                                {{props.item.organization_name}}
                                            </div>
                                        </td>
                                        <td class="text-xs-left body-2 table-text--color">
                                            <div
                                                    class="zawgyi text-truncate"
                                                    style="max-width: 200px;"
                                            >
                                                {{ props.item.description | unescapeString }}
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                            <div class="text-xs-center pt-2">
                                <v-pagination v-model="pagination.page" color="bindezcolor" circle :total-visible="8" :length="pages"></v-pagination>
                            </div>
                        </v-flex>
                        <!-- @click="compareMonitorDialog = false" -->
                        <v-flex sm12 text-xs-right>
                            <v-btn
                                    color="bindezcolor"
                                    @click="cancelCompareMonitor"
                                    outline
                            >
                                <span class="text-capitalize body1 font-weight-regular" style="color: #000;">Cancel</span>
                            </v-btn>
                            <v-btn
                                    color="bindezcolor"
                                    @click="saveCompareMonitor"
                                    dark
                            >
                                <span class="text-capitalize">Compare Monitors</span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-dialog>

            <v-flex ref="keywords" id="keywords" xs12>
                <v-card class="pa-1" flat>
                    <v-card-title class="pb-0" primary-title>
                        <div style="padding-left:8px;" class="section-title--color subheading font-weight-bold">
                            Keywords
                        </div>
                    </v-card-title>
                    <v-layout row wrap>
                        <v-flex :key="index" md6 v-for="(monitor,index) in keywordCompareMetric" xs12>
                            <Keywords
                                    :keywords="monitor.keywords"
                                    :maximumKeywords="15"
                                    :mentionPageReady="comparisonReady && allMonitorFetchReady"
                                    :name="monitor.monitorName"
                                    :created-at="monitor.createdAt"
                            ></Keywords>
                        </v-flex>
                        <v-flex md6 v-show="selectedMonitors.length < 1" xs12 order-md2>
                            <v-card class="d-flex fill-height align-center text-xs-center" flat min-height="300">
                                <span class=" section-title--color text-capitalize body-2">Please Select Monitor</span>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>

            <v-flex ref="mentions" id="mentions" xs12>
                <TotalMentionGraph
                        class="pt-3"
                        :summaryData="mentionCompareMetric"
                        :summaryDataReady="comparisonReady && allMonitorFetchReady"
                />
            </v-flex>

            <v-flex ref="reactions" id="reactions" xs12>
                <v-card flat class="py-4">
                    <v-card-text class="pa-0" ref="compareReactionsChart" >
                        <div class="downloadable-card-header px-4">
                            <h4 class="subheading font-weight-bold text-xs-left section-title--color">
                                Reactions
                            </h4>
                            <v-icon
                                    data-html2canvas-ignore
                                    :disabled="isCanvasImageLoading"
                                    @click="downloadChartToImage($refs.compareReactionsChart, 'Reactions')"
                                    class="ml-auto text-xs-right"
                                    small
                            >
                                fas fa-download
                            </v-icon>
                        </div>
                        <v-layout row wrap>
                            <v-flex md6 xs12 v-for="(reactionCount, index) in reactionCompareMetric" :key="index">
                                <TotalCategoriesGraph
                                        :categoryColor="reactionCategoryColor"
                                        :categoryRangeOrdered="reactionCount.totalCount"
                                        :summaryDataReady="comparisonReady && allMonitorFetchReady"
                                        :isReaction="true"
                                        :name="reactionCount.monitorName"
                                ></TotalCategoriesGraph>
                            </v-flex>
                            <v-flex xs12 md6 v-show="selectedMonitors.length < 1">
                                <v-card min-height="300" class="d-flex fill-height align-center text-xs-center" flat>
                                    <span class=" section-title--color text-capitalize subheading">Please Select Monitor</span>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>

            <div class="flex pa-0 xs12" ref="sentiments">
                <v-flex id="sentiments" xs12>
                    <v-card ref="compareCategoriesChart" class="pa-1" flat>
                        <v-card-title class="pb-0" primary-title>
                            <div class="section-title--color subheading font-weight-bold" style="padding-left:6px;">
                                Sentiments
                            </div>
                            <v-icon
                                    data-html2canvas-ignore
                                    :disabled="isCanvasImageLoading"
                                    @click="downloadChartToImage($refs.compareCategoriesChart.$el, 'Sentiments')"
                                    class="ml-auto text-xs-right"
                                    small
                            >
                                fas fa-download
                            </v-icon>
                        </v-card-title>
                        <v-layout row wrap>
                            <v-flex :key="index" lg6 md6 v-for="(categoryCount,index) in totalCategoriesCompareMetric"
                                    xs12>
                                <TotalCategoriesGraph
                                        :categoryColor="categoryColor"
                                        :categoryRangeOrdered="categoryCount.totalCount"
                                        :isReaction="false"
                                        :name="categoryCount.monitorName"
                                        :summaryDataReady="comparisonReady && allMonitorFetchReady"
                                />
                            </v-flex>
                            <v-flex md6 v-show="selectedMonitors.length < 1" xs12>
                                <v-card class="d-flex fill-height align-center text-xs-center" flat min-height="300">
                                    <span class=" section-title--color text-capitalize subheading">Please Select Monitor</span>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>

                <v-flex xs12>
                    <v-card ref="compareSentimentChart" class="pa-1" flat>
                        <v-card-title class="pb-0" primary-title>
                                <div class="section-title--color subheading font-weight-bold" style="padding-left:6px;">
                                    Sentiments Over Time
                                </div>
                                <v-icon
                                        data-html2canvas-ignore
                                        :disabled="isCanvasImageLoading"
                                        @click="downloadChartToImage($refs.compareSentimentChart.$el, 'Sentiments Over Time')"
                                        class="ml-auto text-xs-right"
                                        small
                                >
                                    fas fa-download
                                </v-icon>
                        </v-card-title>
                        <v-layout row wrap>
                            <v-flex :key="index" id="sentiments" md6 v-for="(sentiment,index) in sentimentCompareMetric"
                                    xs12>
                                <v-card flat height="386">
                                    <SentimentGraph
                                            :categoryColor="categoryColor"
                                            :name="sentiment.monitorName"
                                            :sentimentData="sentiment"
                                            :sentimentGraphSuggestedMax="sentimentGraphSuggestedMax"
                                            :summaryDataReady="comparisonReady && allMonitorFetchReady"
                                    ></SentimentGraph>
                                </v-card>
                            </v-flex>
                            <v-flex md6 v-show="selectedMonitors.length < 1" xs12>
                                <v-card class="d-flex fill-height align-center text-xs-center" flat min-height="300">
                                    <span class=" section-title--color text-capitalize subheading">Please Select Monitor</span>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>

                <v-flex xs12>
                    <v-card ref="comparetotalGroupChart" class="pa-1" flat>
                        <v-card-title class="pb-0" primary-title>
                            <div class="section-title--color subheading font-weight-bold" style="padding-left:6px;">
                                Sentiments Driver
                            </div>
                            <v-icon
                                    data-html2canvas-ignore
                                    :disabled="isCanvasImageLoading"
                                    @click="downloadChartToImage($refs.comparetotalGroupChart.$el, 'Sentiments Over Time')"
                                    class="ml-auto text-xs-right"
                                    small
                            >
                                fas fa-download
                            </v-icon>
                        </v-card-title>
                        <v-layout row wrap>
                            <v-flex :key="index" md6 v-for="(groupCount,index) in totalCategoriesGroupCountCompareMetric"
                                    xs12>
                                <TotalCategoriesGroupCount
                                        :categoryColor="categoryColor"
                                        :limit="10"
                                        :name="groupCount.monitorName"
                                        :summaryData="groupCount.categoriesGroup"
                                        :summaryDataReady="comparisonReady && allMonitorFetchReady"
                                        :totalCategoriesGroupSuggestedMax="totalCategoriesGroupSuggestedMax"
                                />
                            </v-flex>
                            <v-flex md6 v-show="selectedMonitors.length < 1" xs12>
                                <v-card class="d-flex fill-height align-center text-xs-center" flat min-height="300">
                                    <span class=" section-title--color text-capitalize subheading">Please Select Monitor</span>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </div>

            <v-flex ref="topics" id="topics" xs12>
                <v-card ref="compareTopicCloud" flat class="pa-1">
                    <v-card-title class="pb-0" primary-title>
                        <div style="padding-left:6px;" class="section-title--color subheading font-weight-bold">
                            Topic Clouds
                        </div>
                        <v-icon
                                data-html2canvas-ignore
                                :disabled="isCanvasImageLoading"
                                @click="downloadChartToImage($refs.compareTopicCloud.$el, 'Topic Clouds')"
                                class="ml-auto text-xs-right"
                                small
                        >
                            fas fa-download
                        </v-icon>
                    </v-card-title>
                    <v-layout row wrap>
                        <v-flex xs12 md6 v-for="(topic,index) in topicCloudCompareMetric" :key="index">
                            <TopicCloud
                                    :summaryData="topic.topicCloud"
                                    :summaryDataReady="comparisonReady && allMonitorFetchReady"
                                    :name="topic.monitorName"
                            />
                        </v-flex>
                        <v-flex xs12 md6 v-show="selectedMonitors.length < 1">
                            <v-card min-height="300" class="d-flex fill-height align-center text-xs-center" flat>
                                <span class=" section-title--color text-capitalize subheading">Please Select Monitor</span>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>

        </v-layout>
    </v-app>
</template>

<script>
    /* eslint-disable */
	import {mapState, mapActions, mapMutations, mapGetters} from "vuex";
	import SentimentGraph from "@/components/Sentiment/SentimentGraph";
	import TopicCloud from "@/components/Sentiment/TopicCloud";
	import TotalCategoriesGraph from "@/components/TotalCategoriesGraph";
	import TotalCategoriesGroupCount from "@/components/TotalCategoriesGroupCount";
	import TotalMentionGraph from "@/components/Mention/TotalMentionGraph";
	import Keywords from "../components/Mention/Keywords";
	import rabbit from "rabbit-node";

	import _differenceWith from 'lodash/differenceWith';
	import _find from 'lodash/find';
	import _debounce from 'lodash/debounce';
	import _max from 'lodash/max';
	import _includes from 'lodash/includes';
	import _truncate from 'lodash/truncate'
    import _unescape from 'lodash/unescape';
	import _chunk from 'lodash/chunk';

	import downloadChart from "@/mixins/downloadChart";

	export default {
		name: "MonitorComparison",
        mixins:[downloadChart],
		props: ["monitor_uuid"],
		data() {
			return {
				monitorFilter: "all",
				categoryColor: {
					negative: "#EB2929",
					positive: "#1AB177",
					neutral: "#EAC82A",
					interest: "#1F65C5",
					other: "#9e9e9e"
				},
				reactionCategoryColor: {
					like: '#558DFD',
					love: '#FF009D',
					haha: '#F9C02F',
					sad: '#32C5FF',
					wow: '#000000',
					angry: '#FF0100',
				},
				selectedCompareMonitors:[],
                compareMonitorDialog: false,
                searchMonitorValue: '',
                allMonitorFetchReady: true,
                categories:['positive','negative','neutral','interest'],
                reactions: ['like', 'love', 'haha', 'sad', 'wow', 'angry'],
                pagination:{
                    page: 1,
                    rowsPerPage: 10,
                },
				headers: [
					{text: "Monitor Name", width: "200", value: "name", sortable: false, class: "subheading | font-weight-regular"},
					{text: "Type", value: "type", sortable: false},
					{text: "Organization", value: "organization_name", sortable: false, class: "subheading | font-weight-regular"},
					{text: "Description", width: "300", value: "description", sortable: false, class: "subheading | font-weight-regular"},
				],
                monitorMentionColor:["#e76341","#2e5de5", "#d0dd3c", "#05cccd","#b142f0","#13b960"],
                allMonitorCurrentPage:1,
                selectMonitorCurrentPage:1,
                unselectMonitorCurrentPage:1,
			}
		},
		elementActiveMappers:{"monitors":0, "keywords":1, "mentions": 2, "reactions":3, "sentiments": 4, "topics": 5},
        elementIds:["monitors", "keywords","mentions","reactions","sentiments","topics"],
		components: {
			Keywords,
			TotalMentionGraph,
			TopicCloud,
			SentimentGraph,
			TotalCategoriesGraph,
			TotalCategoriesGroupCount,
		},
		computed: {
			...mapState([
				'selectedDate',
				'allAvailableMonitors',
				'monitor',
			]),

			...mapState('comparison', [
                'sentimentGraphSuggestedMax',
                'totalCategoriesGroupSuggestedMax',
                'mentionComparisonMetric',
                'selectedMonitors',
                'comparisonReady'
			]),

			...mapState('sentiment', [
				'selectedTag'
			]),

			...mapState('monitors', [
				'monitorFetchReady'
			]),

			...mapGetters('comparison', [
				'monitorSentiments',
                'monitorReactions',
                'monitorKeywords'
			]),

			pages () {
				if (this.pagination.rowsPerPage == null ||
					this.pagination.totalItems == null
				) return 0
				return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
			},

			monitorsToCompare() {
                return [this.monitor_uuid, ...this.selectedMonitors.map(monitor => monitor.monitor_uuid)]
			},

            mentionCompareMetric(){
				let monitorMentions = Object.entries(this.mentionComparisonMetric);
				return monitorMentions.map((monitor, index) => {
					let curMonitor = this.allAvailableMonitors.find(avaMonitor => avaMonitor.monitor_uuid === monitor[0]);
					let monitorName = curMonitor && _unescape(curMonitor.name);
					return {
						range: monitor[1].range_count,
						label: monitorName,
						backgroundColor: this.monitorMentionColor[index],
						borderColor: this.monitorMentionColor[index],
						fill: false,
                    }
                })
            },

            sentimentCompareMetric(){
				return this.monitorSentiments.map(monitor => {
                    let curMonitor =  _find(this.allAvailableMonitors, ['monitor_uuid', monitor[0]]);
                    let monitorName = curMonitor && curMonitor.name;
					return {
						monitorName,
						range: monitor[1].category_range,
                    }
                })
            },

			totalCategoriesCompareMetric() {
				return this.monitorSentiments.map(monitor => {
					let curMonitor = _find(this.allAvailableMonitors, ['monitor_uuid', monitor[0]]);
					let monitorName = curMonitor && curMonitor.name;
					let totalCount = this.categories.map(category => {
						let foundCategory = monitor[1].category_range.find(cr => cr.value === category);
						return foundCategory || {value: category, count:0}
                    });
					return{
						monitorName,
                        totalCount
                    };
				})
			},

			reactionCompareMetric() {
				return this.monitorReactions.map(monitor => {
					let curMonitor = _find(this.allAvailableMonitors, ['monitor_uuid', monitor[0]]);
					let monitorName = curMonitor && curMonitor.name;
					return {
						monitorName,
						totalCount: this.reactions.map(reaction => {
							let count = monitor[1].count;
							return {
								count: count[`total_${reaction}`],
								field: "category",
								value: reaction,
								img: require(`@/assets/reactions/${reaction[0].toUpperCase() + reaction.slice(1)}.svg`)
							}
						})
					}
				});
			},

			totalCategoriesGroupCountCompareMetric() {
				return this.monitorSentiments.map(monitor => {
					let curMonitor = _find(this.allAvailableMonitors, ['monitor_uuid', monitor[0]]);
					let monitorName = curMonitor && curMonitor.name;
					return {
						monitorName,
						categoriesGroup: monitor[1].tags_sentiments_cloud_data
					}
				})
			},

            topicCloudCompareMetric(){
				return this.monitorSentiments.map(monitor => {
					let curMonitor = _find(this.allAvailableMonitors, ['monitor_uuid', monitor[0]]);
					let monitorName = curMonitor && curMonitor.name;
					return {
						monitorName,
						topicCloud: monitor[1].tags_sentiments_cloud_data
                    }
                })
            },

			keywordCompareMetric() {
				return this.monitorKeywords.map(monitor => {
					return {
						monitorName: monitor[1].name,
                        createdAt: monitor[1].created_at,
						keywords: monitor[1].keywords.map(keyword => ({
							name: rabbit.uni2zg(keyword),
							color: "#4FAF79",
							icon: "close",
							available: true
                        }))
					}
				})
			},

            unSelectMonitor(){
				return _differenceWith(this.allAvailableMonitors, this.monitorsToCompare, _includes);
            }
		},

		methods: {
			...mapActions([
				'fetchMonitors',
                'fetchMonitor'
			]),

			...mapActions('comparison', [
				'fetchMentionComparisonMetric',
                'fetchSentimentComparisonMetric',
                'fetchReactionComparisonMetric',
                'fetchKeywordsComparisonMetric',
			]),

			...mapMutations([
				'setAllAvailableMonitors',
			]),

			...mapMutations('comparison', [
                'setSentimentGraphSuggestedMax',
                'setTotalCategoriesGroupSuggestedMax',
                'setDefaultState',
                'setSelectedMonitors',
                'setComparisonReady',
                'setActiveSection'
			]),

			scrollSection(sectionId) {
				this.$vuetify.goTo(sectionId)
			},

			updateSuggestedMaxValue() {
				let sentimentRanges = this.sentimentCompareMetric.map(monitor => monitor.range).map(range => range.map(r => r.ranges));

				let sentimentSuggestMax = _max(sentimentRanges.flat().map(range => _chunk(range.fb_created_dt.counts,2).map(crange => crange[1])).flat());
				let totalCategoriesGroupSuggestMax = _max(this.totalCategoriesGroupCountCompareMetric.map(monitor => Object.values(monitor.categoriesGroup)).flat(2).map(categories => categories.count));
				this.setSentimentGraphSuggestedMax(sentimentSuggestMax);
				this.setTotalCategoriesGroupSuggestedMax(totalCategoriesGroupSuggestMax);
			},

			fetchAllMonitors() {
				this.allMonitorFetchReady = false;
				this.fetchMonitors({filterPurpose: true}).then(({monitors, total_page, current_page}) => {
					return Promise.all((new Array(total_page - 1)).fill(undefined).map((v, index) => {
						return this.fetchMonitors({page: index + 2, filterPurpose: true});
					})).then((data) => {
						this.allMonitorFetchReady = true;
						data.push({monitors, total_page, current_page});
						return data.map((d) => d.monitors).reduce((cur, car) => {
							return [].concat(cur, car);
						});
					});
				}).then(this.setAllAvailableMonitors);
			},

			compareMonitors() {
				let data = {
					monitor_uuids: this.monitorsToCompare,
					timerange: this.selectedDate
				};
				this.setComparisonReady(false);
				Promise.all([
					this.fetchMentionComparisonMetric(data),
					this.fetchSentimentComparisonMetric(data),
                    this.fetchReactionComparisonMetric(data),
                    this.fetchKeywordsComparisonMetric({monitor_uuids: this.monitorsToCompare}),
				]).then(_ => {
					this.setComparisonReady(true);
				})
			},

            //check which monitor to disable!
			disabledMonitors(item) {
				return (item.monitor_uuid === this.monitor_uuid) || (this.selectedCompareMonitors.length === 5 && !_find(this.selectedCompareMonitors, monitor => monitor.monitor_uuid === item.monitor_uuid))
			},

			customMonitorFilter(items, search, filter) {
				let predicate = () => true;
				if (this.monitorFilter === 'select') {
					predicate = item => this.monitorsToCompare.some(uuid => uuid === item.monitor_uuid);
				} else if (this.monitorFilter === 'unselect') {
					predicate = item => this.unSelectMonitor.some(monitor => monitor.monitor_uuid === item.monitor_uuid);
				}
				return items.filter(predicate).filter(i => Object.keys(i).some(j => filter(i[j], search)))
			},

			cancelCompareMonitor() {
				this.compareMonitorDialog = false;
                this.selectedCompareMonitors = this.selectedMonitors;
			},

            saveCompareMonitor(){
				this.setSelectedMonitors(this.selectedCompareMonitors);
				this.compareMonitors();
				this.compareMonitorDialog = false;
            },

			scrollAction: _debounce(function (e) {
				let fromTop = window.scrollY;
				this.$options.elementIds.forEach(ele => {
					let elements = this.$refs;
					if (elements[ele].offsetTop <= fromTop && elements[ele].offsetTop + elements[ele].offsetHeight > fromTop) {
						this.setActiveSection(this.$options.elementActiveMappers[ele])
					}
				});
			}, 150)
		},

		created() {
			if(this.allAvailableMonitors.length < 1 ) this.fetchAllMonitors();
			let monitor = this.monitorSentiments[0] || [];
			this.selectedCompareMonitors = this.selectedMonitors;
            if(monitor[0] !== this.monitor_uuid){
				this.setDefaultState();
				this.selectedCompareMonitors = [];
				this.compareMonitors();
            }
		},

		watch: {
			totalCategoriesGroupCountCompareMetric: {
				handler(val) {
					this.updateSuggestedMaxValue();
				},
				deep: true,
                immediate:true
			},

			sentimentCompareMetric: {
				handler(val) {
					this.updateSuggestedMaxValue();
				},
				deep: true,
                immediate: true
			},

			allAvailableMonitors(monitors) {
				this.$set(this.pagination, "totalItems", monitors.length);
			},

			monitorFilter(filter, oldVal) {
				this.searchMonitorValue = '';
				this.$data[`${oldVal}MonitorCurrentPage`] = this.pagination.page;
				if (filter == "all") {
					this.pagination.totalItems = this.allAvailableMonitors.length;
					this.pagination.page = this.allMonitorCurrentPage;
				} else if (filter == 'select') {
					this.pagination.totalItems = this.monitorsToCompare.length;
					this.pagination.page = this.selectMonitorCurrentPage;
				} else if (filter == 'unselect') {
					this.pagination.totalItems = this.unSelectMonitor.length;
					this.pagination.page = this.unselectMonitorCurrentPage;
				}
			},
		},
        filters:{
			textTruncate(raw){
				return _truncate(raw, {length: 24});
            }
        }

	}
</script>

<style>
    .v-btn.v-btn--small, .v-btn.v-btn--large {
        height: 41px;
    }

    .table-text--color {
        color: rgba(0, 0, 0, 0.6);
    }

    .custom-position{
        margin-right: 7px;
    }

    /*.app-compo-selector.v-text-field--solo .v-input__slot{*/
    /*    border: 1px solid #1AB177;*/
    /*}*/

</style>
